export const RELEASE_DATE = new Date('2026-08-24T17:00:00Z');
export const RELEASE_DATE_LABEL = 'August 24, 2026';

export function getTimeLeft(now = Date.now(), releaseDate = RELEASE_DATE) {
  const diff = releaseDate.getTime() - now;
  const overdue = diff < 0;
  const elapsed = Math.abs(diff);
  return {
    overdue,
    days: Math.floor(elapsed / 86400000),
    hours: Math.floor(elapsed / 3600000) % 24,
    minutes: Math.floor(elapsed / 60000) % 60,
    seconds: Math.floor(elapsed / 1000) % 60,
  };
}

export function formatCountdownUnit(value) {
  return String(value).padStart(2, '0');
}
